<template>
  <nav class="breadcrumbs">
    <template v-for="(item, index) in items" :key="item.path">
      <!-- Chevron separator -->
      <svg
        v-if="index > 0"
        class="breadcrumbs__chevron"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <polyline points="15 18 9 12 15 6" />
      </svg>

      <!-- Link or span for current item -->
      <span
        v-if="index === items.length - 1"
        class="breadcrumbs__item breadcrumbs__item--current"
      >
        {{ item.label }}
      </span>
      <router-link
        v-else
        @click="item.func"
        :to="{path: item.path}"
        class="breadcrumbs__item breadcrumbs__item--link"
      >
        {{ item.label }}
      </router-link>
    </template>
  </nav>
</template>

<script>
export default {
  name: 'Breadcrumbs',
  props: {
    items: {
      type: Array,
      required: true,
      validator: (items) => {
        return items.every(item => 
          typeof item.label === 'string' && 
          typeof item.path === 'string'
        );
      }
    }
  }
}
</script>

<style lang="scss">
// Variables
$color-primary: #4B5563;
$color-dark: #111827;
$color-light: #6B7280;
$transition-duration: 0.2s;
$spacing-unit: 0.5rem;
$font-size-base: 0.875rem;

// Mixins
@mixin hover-transition {
  transition: all $transition-duration ease-in-out;
}

.breadcrumbs {
  display: flex;
  align-items: center;
  font-size: $font-size-base;
  color: $color-primary;
  
  // Chevron icon
  &__chevron {
    width: 1rem;
    height: 1rem;
    margin: 0 $spacing-unit;
    flex-shrink: 0;
    color: $color-light;
  }
  
  // Common styles for items
  &__item {
    position: relative;
    line-height: 1.5;
    
    // Current page (non-link)
    &--current {
      font-weight: 500;
      color: var(--btn_color);
    }
    
    // Link items
    &--link {
      text-decoration: none;
      color: $color-primary;
      @include hover-transition;
      
      &:hover {
        color: var(--btn_color);
        
        &::after {
          width: 100%;
        }
      }
      
      // Underline effect on hover
      &::after {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 0;
        width: 0;
        height: 1px;
        background-color: $color-dark;
        @include hover-transition;
      }
    }
  }
  
  // Responsive adjustments
  @media (max-width: 640px) {
    font-size: $font-size-base * 0.9;
    
    &__chevron {
      width: 0.875rem;
      height: 0.875rem;
      margin: 0 ($spacing-unit * 0.75);
    }
  }
}
</style>